import React from 'react';
import { apiBatchRequest, apiPost } from '../../../utils/api_service';
import { API_URL } from '../../../constants/api';
import { ShowToast, toastType } from '../../../utils/toast-service';
import { getSectionAttributeValueByKey, setSectionFieldAttributeByKey, UpdateFieldsWithConfiguration, cloneDeep, setSectionAttributeValueByKey, getDistinctByProperty } from '../../../utils/helper';
import commonLabels from '../../../constants/messageConstants';
import FormGenerator from '../../common/FormGenerator';
import { controlType } from '../../../constants/common';
import { ServiceTypes, SOURCE_ACCOUNTING_TYPE } from '../../../constants/appConstants';
import ConfirmDialog from '../../common/Dailogbox/confirmDailog';

// Property Details Component
class PropertyDetails extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      MarketDetails: undefined,
      PropertyData: undefined,
      configuration: undefined,
      updatedPropertyDetails: [],
      sourceAccountingSystemData: [],
      propertySubTypeData: [],
      originalPropertySubTypeData: [],
      sourceAccountingSystemId: 0,
      isFreezed: true,
      isClientSourceAccounting: this.props.isClientSourceAccounting,
      selectedSourceAccoutingTypeId: this.props.isClientSourceAccounting ? 2 : 1,
      employeesAllMasterData: [],
      controllerEmployeesMasterData: [],
      allMarketStateData: [],
      supervisorMasterData: [],
      openDialog: false,
      confirmationMessage: ''
    };
  }

  // Component Did Mount event to get API data
  componentDidMount() {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Property.GetPropertyDetails,
        key: 'PropertyDetailsData',
        params: { propertyId: this.props.selectedPropertyId }
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'MarketMasterData'
      },
      {
        url: API_URL.Employee.GetDepartmentMasterData,
        key: 'DepartmentMasterData'
      },
      {
        url: API_URL.Property.GetPropertyData,
        key: 'PropertyData',
        params: { marketId: this.props.selectedPropertyId }
      },
      {
        url: API_URL.Transition.GetSourceAccounting,
        key: 'sourceAccountingSystemData'
      },
      {
        url: API_URL.Property.GetPropertySubType,
        key: 'propertySubTypeData',
        fromCache: true,
        duration: 60
      },
      {
        url:
          API_URL.Employee.GetEmployeeMasterData +
          '?showInActive=true&outputType=ListAll',
        key: 'employeesAllMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: `${API_URL.Market.GetMarketCityStateMasterData}?stateId=${-1}`,
        key: 'allMarketStateData'
      },
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true&departmentId=' + 30,
        key: 'supervisorMasterData'
      },
      {
        url:
          API_URL.Employee.GetControllerDetail +
          '?outputType=List',
        key: 'controllerEmployeesMasterData',
        fromCache: true,
        duration: 15
      }
    ])
      .then(({ allMarketStateData, PropertyDetailsData, MarketMasterData, DepartmentMasterData, PropertyData, sourceAccountingSystemData, propertySubTypeData, employeesAllMasterData, supervisorMasterData, controllerEmployeesMasterData }) => {
        if (PropertyDetailsData.success === true) {
          const serviceTypesId = getSectionAttributeValueByKey(
            PropertyDetailsData.data,
            'ServiceTypeId'
          ).split('|');
          if (serviceTypesId.find(x => x?.toString() === ServiceTypes.Property_Accounting?.toString()) !== undefined) {
            setSectionFieldAttributeByKey(PropertyDetailsData.data, 'ARAdminName', 'isVisible', true);
          } else {
            setSectionFieldAttributeByKey(PropertyDetailsData.data, 'ARAdminName', 'isVisible', false);
          }
          const sourceAccountingTypeId = getSectionAttributeValueByKey(PropertyDetailsData.data, 'SourceAccountingSystemId');
          if (sourceAccountingTypeId?.toString() === SOURCE_ACCOUNTING_TYPE.STREAM_ACCOUNTING_SYSTEM?.toString()) {
            setSectionFieldAttributeByKey(PropertyDetailsData.data, 'YardiCode', 'dataFormat', 'Text');
          } else {
            setSectionFieldAttributeByKey(PropertyDetailsData.data, 'YardiCode', 'dataFormat', 'NumericText');
          }
          this.setState({
            isFreezed: getSectionAttributeValueByKey(PropertyDetailsData.data, 'IsFreezed') === '0',
            PropertyDetailsData: PropertyDetailsData.data,
            responsePropertyDetailsData: cloneDeep(PropertyDetailsData.data),
            employeesAllMasterData: employeesAllMasterData.data || [],
            allMarketStateData: allMarketStateData.data || [],
            PropertyData: PropertyData.data || [],
            configuration: PropertyData.config,
            DepartmentMasterData: DepartmentMasterData.data || [],
            MarketMasterData: MarketMasterData.data || [],
            sourceAccountingSystemData: sourceAccountingSystemData.data || [],
            propertySubTypeData: propertySubTypeData.data || [],
            originalPropertySubTypeData: propertySubTypeData.data || [],
            supervisorMasterData: supervisorMasterData.data || [],
            controllerEmployeesMasterData: controllerEmployeesMasterData.data || []
          });
        } else {
          ShowToast(commonLabels.somethingWrong, toastType.ERROR, 5000, 500, 'Server error');
        }
      })
      .catch(() => {
        this._asyncRequest = null;
        ShowToast(commonLabels.somethingWrong, toastType.ERROR, 5000, 500, 'Server error');
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Get property changes
  getPropertyChnages = (formFields) => {
    this.setState({ updatedPropertyDetails: formFields });
    this.UpdatePropertyField(formFields);
  };

  // Source accounting change event
  getSourceAccountingDetails = (value, sourceIdField) => {
    this.setState({ sourceAccountingSystemId: sourceIdField.value, selectedSourceAccoutingTypeId: sourceIdField.value, reloadProperty: !this.state.reloadProperty });    
  }

  // AR Admin change event
  onAdminChanges = (value, sourceIdField) => {
    const { responsePropertyDetailsData, PropertyDetailsData } = this.state;
    const propertyName = getSectionAttributeValueByKey(responsePropertyDetailsData, 'PropertyName');
    const currentAdminName = getSectionAttributeValueByKey(responsePropertyDetailsData, 'ARAdminName');

    if ((currentAdminName || '') !== '' && currentAdminName !== value) {
      let msg = '';
      if ((value || '') !== '') {
        msg = currentAdminName + ' is assigned as a AR Admin to the property ' + propertyName + '. Do you want to change the AR Admin as ' + value + '?';
      } else {
        msg = currentAdminName + ' is assigned as a AR Admin to the property ' + propertyName + '. Do you want to unassign the AR Admin?';
      }
      this.setState({ openDialog: true, confirmationMessage: msg, selectedAdminName: value });
    } else {
      setSectionAttributeValueByKey(
        PropertyDetailsData,
        'ARAdminName',
        value
      );
      this.setState({ openDialog: false, confirmationMessage: '', selectedAdminName: value, PropertyDetailsData });
    }
  }

  // Confirmation option select event
  onConfirmClickHandle = (value) => {
    if (value) {
      const { PropertyDetailsData, selectedAdminName } = this.state;
      setSectionAttributeValueByKey(
        PropertyDetailsData,
        'ARAdminName',
        selectedAdminName
      );
      this.setState({
        openDialog: false,
        confirmationMessage: '',
        selectedAdminName: '',
        PropertyDetailsData
      });
    } else {
      const { PropertyDetailsData, responsePropertyDetailsData } = this.state;
      const currentAdminName = getSectionAttributeValueByKey(responsePropertyDetailsData, 'ARAdminName');
      setSectionAttributeValueByKey(
        PropertyDetailsData,
        'ARAdminName',
        currentAdminName
      );
      this.setState({
        openDialog: false,
        confirmationMessage: '',
        selectedAdminName: '',
        PropertyDetailsData
      });
    }
  }

  // Update property field
  UpdatePropertyField = (updatedPropertyDetails) => {
    const { supervisorMasterData } = this.state;
    const arAdminName = getSectionAttributeValueByKey(updatedPropertyDetails, 'arAdminName')?.trim();
    const arAdminId = supervisorMasterData.find(x => x.employeeName === arAdminName)?.employeeId || null;
    const postBody = {
      propertyId: parseInt(getSectionAttributeValueByKey(updatedPropertyDetails, 'propertyId')),
      propertyName: getSectionAttributeValueByKey(updatedPropertyDetails, 'propertyName')?.trim(),
      streamlinePropertyName: getSectionAttributeValueByKey(updatedPropertyDetails, 'streamlinePropertyName')?.trim(),
      propertyCode: getSectionAttributeValueByKey(updatedPropertyDetails, 'yardiCode')?.trim(),
      sourceAccountingSystemId: parseInt(getSectionAttributeValueByKey(updatedPropertyDetails, 'sourceAccountingSystemId')),
      propertySubTypeId: parseInt(getSectionAttributeValueByKey(updatedPropertyDetails, 'propertySubTypeId')),
      address: getSectionAttributeValueByKey(updatedPropertyDetails, 'address')?.trim(),
      areaSf: getSectionAttributeValueByKey(updatedPropertyDetails, 'areaSf')?.trim(),
      city: getSectionAttributeValueByKey(updatedPropertyDetails, 'city')?.trim(),
      state: getSectionAttributeValueByKey(updatedPropertyDetails, 'state')?.trim(),
      zipCode: getSectionAttributeValueByKey(updatedPropertyDetails, 'zipCode')?.trim(),
      controllerName: getSectionAttributeValueByKey(updatedPropertyDetails, 'controllerName')?.trim(),
      arAdminId: arAdminId

    };
    apiPost({
      url: API_URL.Property.UpdatePropertyField,
      params: {},
      postBody: postBody
    }).then(({ data: response }) => {
      if (response.success) {
        ShowToast(
          'Property updated successfully.',
          toastType.SUCCESS,
          5000,
          500
        );
        this.setState({
          PropertyDetailsData: undefined
        }, () => {
          this.props.onBackClick();
        });
      } else {
        ShowToast(
          response.message,
          toastType.ERROR,
          5000,
          500
        );
      }
    });
  }

  // render event
  render() {
    const { employeesAllMasterData, allMarketStateData, isFreezed, isClientSourceAccounting, PropertyDetailsData, MarketMasterData, DepartmentMasterData, originalPropertySubTypeData, supervisorMasterData, controllerEmployeesMasterData } = this.state;
    const propertySubTypeData = cloneDeep(originalPropertySubTypeData);
    const value = getSectionAttributeValueByKey(PropertyDetailsData, 'PropertyTypeName');
    let isEditable = true;
    if (propertySubTypeData.find(x => x.propertySubTypeName === value) !== undefined) {
      setSectionAttributeValueByKey(
        PropertyDetailsData,
        'PropertySubTypeName',
        value
      );
      setSectionAttributeValueByKey(
        PropertyDetailsData,
        'PropertySubTypeId',
        getSectionAttributeValueByKey(PropertyDetailsData, 'PropertyTypeId')
      );
      setSectionFieldAttributeByKey(
        PropertyDetailsData,
        'PropertySubTypeName',
        'isEditable',
        false
      );
      isEditable = false;
    } else {
      setSectionFieldAttributeByKey(
        PropertyDetailsData,
        'PropertySubTypeName',
        'isEditable',
        true
      );
      isEditable = true;
    }
    const DetailsFormConfig = [
      {
        key: 'propertyName',
        type: controlType.TextBox,
        shrink: true,
        isEditable: isClientSourceAccounting && isFreezed
      },
      {
        key: 'streamlinePropertyName',
        type: controlType.TextBox,
        shrink: true,
        isEditable: isClientSourceAccounting && isFreezed
      },
      {
        key: 'propertyTypeName',
        type: controlType.TextBox,
        shrink: true,
        isEditable: false
      },
      {
        key: 'sourceAccountingSystem',
        isEditable: isFreezed,
        type: controlType.DropDown,
        changePropertyCodeValidations: true,
        onChange: this.getSourceAccountingDetails
      },
      {
        key: 'propertySubTypeName',
        type: controlType.DropDown,
        multiple: false,
        isEditable: isEditable
      },
      {
        key: 'yardiCode',
        type: controlType.TextBox,
        dataFormat: this.state.selectedSourceAccoutingTypeId?.toString() === '1' ? 'Text' : 'NumericText',
        shrink: true,
        isEditable: isFreezed
      },
      {
        key: 'marketName',
        type: controlType.TextBox,
        shrink: true,
        isEditable: false
      },
      {
        key: 'city',
        type: controlType.TextBox,
        shrink: true,
        isEditable: isFreezed
      },
      {
        key: 'address',
        type: controlType.TextBox,
        shrink: true,
        isEditable: isFreezed
      },
      {
        key: 'state',
        type: controlType.DropDown,
        shrink: true,
        isEditable: isFreezed
      },
      {
        key: 'controllerName',
        type: controlType.DropDown,
        shrink: true,
        isEditable: isFreezed
      },
      {
        key: 'zipCode',
        type: controlType.TextBox,
        shrink: true,
        isEditable: isFreezed
      },
      {
        key: 'TotalFloors',
        type: controlType.TextBox,
        shrink: true,
        isEditable: isFreezed
      },
      {
        key: 'Address',
        type: controlType.TextBox,
        shrink: true,
        isEditable: isFreezed
      },
      {
        key: 'TotalUnits',
        type: controlType.TextBox,
        shrink: true,
        isEditable: isFreezed
      },
      {
        key: 'ClientName',
        type: controlType.TextBox,
        shrink: true,
        isEditable: false
      },
      {
        key: 'LegalEntity',
        type: controlType.TextBox,
        shrink: true,
        isEditable: false
      },
      {
        key: 'AreaSF',
        type: controlType.TextBox,
        shrink: true,
        isEditable: isFreezed
      },
      {
        key: 'arAdminName',
        type: controlType.DropDown,
        multiple: false,
        isEditable: isFreezed
      }
    ];
    const dropDownSource = [{
      key: 'marketName',
      option: 'marketName',
      idField: 'marketId',
      source: MarketMasterData
    },
    {
      key: 'typeName',
      option: 'departmentName',
      idField: 'departmentId',
      source: DepartmentMasterData
    },
    {
      key: 'sourceAccountingSystem',
      option: 'sourceAccountingSystem',
      idField: 'sourceAccountingSystemId',
      source: this.state.sourceAccountingSystemData
    },
    {
      key: 'propertySubTypeName',
      option: 'propertySubTypeName',
      idField: 'propertySubTypeId',
      source: propertySubTypeData,
      autoSelect: true
    },
    {
      key: 'controllerName',
      option: 'employeeName',
      source: controllerEmployeesMasterData,
      applyfilter: true,
      filterMode: 'strict',
      autoSelect: true
    },
    {
      key: 'state',
      option: 'stateName',
      autoSelect: true,
      source: getDistinctByProperty(
        allMarketStateData || [],
        'stateCode'
      )
    },
    {
      key: 'arAdminName',
      option: 'employeeName',
      autoSelect: true,
      onChange: this.onAdminChanges,
      source: getDistinctByProperty(
        supervisorMasterData || [],
        'employeeName'
      )
    }];
    return (
      <>
        {this.state.openDialog &&
          <ConfirmDialog
            IsOpen={this.state.openDialog}
            Message={this.state.confirmationMessage}
            OnHandelClick={(isConfirmed) => {
              this.onConfirmClickHandle(isConfirmed);
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          />
        }
        {PropertyDetailsData && (
          <>
            <FormGenerator gridColumn={2}
              formFields={UpdateFieldsWithConfiguration(PropertyDetailsData, DetailsFormConfig)}
              dropDownSource={dropDownSource}
              saveChanges={this.props.Editable ? this.getPropertyChnages : undefined}
              ReloadForm={this.state.reloadProperty}
              Editable={this.props.Editable}
            />

            {' '}
          </>
        )}
      </>
    );
  }
}

export default PropertyDetails;
